<template>
    <BCol cols="12" :md="vsMd" :lg="vsLg">
        <ValidationProvider #default="validationContext" :name="$t(vsName)" :rules="vsRules">
            <BFormGroup :label="$t(vsName)" :label-for="vsName.toLowerCase()" :class="vsRequired == '' ? 'required-field' : ''">
                <vSelect :value="vsModel" @input="inputFunctions($event)" @search="onSearch" :multiple="vsMultiple == '' ? true : false " :label="vsLabel" :clearable="vsClearable ? vsClearable : false" :options="vsOptions" :reduce="vsReduce" :input-id="vsName.toLowerCase()" :disabled="vsDisabled" >
                    <template #option="option">
                        <!-- <option v-if="option=='first'" :disabled="true"> 3 caractres  </option> -->

                        <option >{{ option[vsLabel] }}</option>
                    </template>
                </vSelect>
                <BFormInvalidFeedback :state="getValidationState(validationContext)"> {{validationContext.errors[0]}} </BFormInvalidFeedback>
            </BFormGroup>
        </ValidationProvider>
    </BCol>
</template>

<script>
import { BCol, BFormGroup, BFormInvalidFeedback } from 'bootstrap-vue';
import { ValidationProvider } from 'vee-validate';
import formValidation from '@core/comp-functions/forms/form-validation';
import vSelect from 'vue-select'
import { toRefs } from '@vue/composition-api';

export default {
    components:{ ValidationProvider, BCol, BFormGroup, BFormInvalidFeedback, vSelect },
    props: ['vsName', 'vsModel', 'vsMd', 'vsRules', 'vsRequired', 'vsOptions', 'vsLabel', 'vsMultiple', 'vsReduce', 'vsLg', 'vsClearable', 'vsDisabled'],
    emit: ['update:vsModel', 'vsOnInput', 'vsOnSearch'],
    setup(props, ctx) {
        const { getValidationState } = formValidation()
        let timer = 0
        const delay = 500
        const { vsLabel, vsOptions} = toRefs(props)



        const inputFunctions = function(event){
            ctx.emit('update:vsModel', event)
            ctx.emit('vsOnInput', event)
        }


        const onSearch = function (val) {
            clearTimeout(timer)
            timer = setTimeout(() => {
                if(val.length > 2) {
                    ctx.emit('vsOnSearch', val)
                }
            }, delay)
        }

        return {
            inputFunctions,
            getValidationState,
            onSearch
        }
    },
}
</script>

<style lang="scss">
  @import '~@core/scss/vue/libs/vue-select.scss';
</style>
